// Coordinates the staged onscreen-character form through one feature-level controller.
import { Controller } from '@hotwired/stimulus';
import { OnscreenCharacterRoster } from '../lib/onscreen_character_roster';
import { UnsavedChangesGuard } from '../lib/unsaved_changes_guard';

export default class extends Controller {
  static targets = [
    'character',
    'fallbackFocus',
    'noMatches',
    'offScreenEmpty',
    'offScreenList',
    'onScreenEmpty',
    'onScreenList',
    'query'
  ];
  static classes = ['hidden'];
  static values = { baseline: String, message: String };

  connect() {
    this.roster = new OnscreenCharacterRoster(this);
    this.guard = new UnsavedChangesGuard(this, this.baselineValue);
    this.modalFrame = this.element.closest('turbo-frame#modal, turbo-frame#drawer-modal');
    this.modalClosingHandler = (event) => this.guard.confirmModalClose(event);
    this.modalFrame?.addEventListener('modal:closing', this.modalClosingHandler);
    this.serialize();
  }

  disconnect() {
    this.modalFrame?.removeEventListener('modal:closing', this.modalClosingHandler);
    this.guard.disconnect();
  }

  change(event) {
    this.guard.update(this.roster.change(event));
  }

  sorted() {
    this.serialize();
  }

  serialize() {
    this.guard.update(this.roster.synchronize());
  }

  filter(event) {
    this.roster.filter(event);
  }

  clear(event) {
    this.roster.clear(event);
  }

  cancel() {
    this.guard.cancel();
  }

  submitStart() {
    this.element.inert = true;
  }

  submitEnd(event) {
    this.element.inert = false;
    if (event.detail.success) this.guard.submitSucceeded(this.roster.synchronize());
  }

  confirmClick(event) {
    this.guard.confirmClick(event);
  }

  confirmVisit(event) {
    this.guard.confirmVisit(event);
  }

  confirmUnload(event) {
    this.guard.confirmUnload(event);
  }

  confirmHistory(event) {
    this.guard.confirmHistory(event);
  }
}
